
// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { FiTrash2 } from "react-icons/fi";
// import {
//   FaRegEnvelope,
//   FaRegCalendarAlt,
//   FaRegFileAlt,
//   FaPaw,
//   FaStar,
//   FaStethoscope,
// } from "react-icons/fa";
// import { useDispatch, useSelector } from "react-redux";
// import { deleteUser, fetchUserById } from "../../redux/slices/userSlice";
// import { MdOutlineArrowBackIos } from "react-icons/md";
// import DeleteModal from "../../components/common/DeleteModal"; // ✅ import modal

// export default function UserProfile() {
//   const { type, id } = useParams();
//   const userType = type;
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const [modalOpen, setModalOpen] = useState(false);

//   const profile = useSelector((state) => state.users.profile);
//   const profileStatus = useSelector((state) => state.users.profileStatus);

//   useEffect(() => {
//     dispatch(fetchUserById({ userType, id }));
//   }, [dispatch, userType, id]);

//   if (profileStatus === "loading")
//     return <div className="px-20 pt-10">Loading...</div>;
//   if (profileStatus === "failed")
//     return <div className="px-20 pt-10">Failed to load user data.</div>;
//   if (!profile) return <div className="px-20 pt-10">User not found.</div>;

//   const user = profile;
//   const isPetParent = type === "pet-parents";

//   // 🔥 Handle Delete
//   const handleDelete = () => {
//     console.log("Deleting user:", user.id, "of type:", userType);
//     dispatch(deleteUser({ userType, id })) 
//     setModalOpen(false);
//     navigate(-1); // Go back after delete
//   };

//   return (
//     <div className="relative min-h-screen bg-white font-inter px-6 pt-12">
//       {/* Top bar: Back + Title + Delete */}
//       <div className="flex justify-between items-start mb-8">
//         <div className="flex items-start">
//           {/* Arrow */}
//           <button
//             onClick={() => navigate(-1)}
//             aria-label="Go Back"
//             className="mt-1 mr-3 p-4 text-2xl text-gray-800 hover:text-blue-600"
//           >
//             <MdOutlineArrowBackIos />
//           </button>

//           {/* Title + Subtitle */}
//           <div>
//             <div className="text-2xl font-bold text-black">
//               {isPetParent ? "Pet Parent Profile" : "Veterinarian Profile"}
//             </div>
//             <div className="text-gray-700 text-base font-normal mt-1">
//               View detailed information and take actions if needed.
//             </div>
//           </div>
//         </div>

//         <button
//           onClick={() => setModalOpen(true)}
//           className="flex items-center gap-2 bg-[#2B80FF] hover:bg-blue-600 text-white font-medium px-6 py-2 rounded-lg text-lg shadow transition-all"
//         >
//           Delete <FiTrash2 className="text-[18px]" />
//         </button>
//       </div>

// <div className="flex mt-10 justify-between items-start px-10">
// <div className="flex flex-col gap-2 w-1/2 min-w-[24rem]">
//           <div className="flex items-center">
//             <img
//               src={user.avatar || "https://randomuser.me/api/portraits/lego/1.jpg"}
//               alt={user.name}
//               className="rounded-full w-20 h-20 object-cover mr-5 border"
//             />
//             <div>
// <div className="text-xl font-bold text-black">
//                 {user.name}
//               </div>
//               {!isPetParent && (
//                 <>
//                   <div className="text-gray-700 text-[16px] leading-tight mt-1">{user.specialty}</div>
//                   {user.subspecialty && (
//                     <div className="text-gray-700 text-[16px] leading-tight">{user.subspecialty}</div>
//                   )}
//                 </>
//               )}
//             </div>
//           </div>
//             <div className="ml-24 px-10"> 
//             {isPetParent ? (
//               <div className="mt-4 flex flex-col gap-3 text-[16px] text-gray-800">
//                 <div className="flex items-center gap-2">
//                   <FaRegEnvelope className="text-blue-600" /> {user.email}
//                 </div>
//                 <div className="flex items-center gap-2">
//                   <FaRegCalendarAlt className="text-blue-600" /> Joined {user.joined}
//                 </div>
//                 <div className="flex items-center gap-2">
//                   <FaRegFileAlt className="text-blue-600" /> {user.consultations} Consultations
//                 </div>
//               </div>
//             ) : (
//               <div className="mt-4 flex flex-col gap-3 text-[16px] text-gray-800">
//                 <div className="flex items-center gap-2">
//                   <FaRegEnvelope className="text-blue-600" /> {user.email}
//                 </div>
//                 <div className="flex items-center gap-2">
//                   <FaStethoscope className="text-blue-600" /> {user.experience || "8 Years experience"}
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Second half info */}
//         <div className="w-1/2 flex flex-col items-end mt-24 ">
//           {isPetParent ? (
//             <div className="flex flex-col items-start gap-3 w-full text-right text-[16px] text-gray-800 mt-4">
//               <div className="flex items-center gap-2 justify-end">
//                 <FaRegCalendarAlt className="text-blue-600" />
//                 <span>Last visit {user.lastVisit}</span>
//               </div>
//               <div className="flex items-center gap-2 justify-end">
//                 <FaStar className="text-blue-600" />
//                 <span>Engagement : {user.engagement}%</span>
//               </div>
//             </div>
//           ) : (
//             <div className="w-full flex flex-col items-start">
//               <div className="text-black text-lg font-semibold mb-3">Documents</div>
//               <div className="flex gap-3">
//                 {(user.documents || ["License", "CV", "Certificate"]).map((doc, i) => (
//                   <button
//                     key={i}
//                     className="border border-blue-400 px-5 py-1 rounded-lg text-blue-700 font-medium bg-white hover:bg-blue-50 text-base transition-all"
//                   >
//                     {doc}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Pets Section */}
//       {isPetParent && (
//         <>
//           <div className="mt-10 mb-1 text-lg font-semibold text-black px-10">Pets</div>
//           <div className="flex flex-col gap-4 pl-10 max-w-full">
//             {(user.pets || []).map((pet, i) => (
//               <div
//                 key={i}
//                 className="rounded-xl bg-blue-200 flex items-start gap-3 px-6 py-3 min-h-[54px]"
//               >
//                 <FaPaw className="flex-shrink-0 mt-1 text-blue-700" />
//                 <div>
//                   <div className="font-semibold text-[16px] text-black">{pet.name}</div>
//                   <div className="text-gray-600 text-[15px]">{pet.type} &bull; {pet.age}</div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </> 
//       )}

//       {/* Buttons below profile/pet cards */}
//       <div className="flex gap-4 mt-28 justify-end">
//         <button
//           onClick={() => navigate(-1)}
//           className="border border-[#2B80FF] text-blue-700 rounded-lg px-8 py-2 text-lg font-medium bg-white hover:bg-blue-50 transition-all"
//         >
//           Cancel
//         </button>
//         <button
//           onClick={() => navigate(`/admin/profile/${userType}/${id}/edit`)}
//           className="bg-[#2B80FF] text-white rounded-lg px-8 py-2 text-lg font-medium hover:bg-blue-600 transition-all shadow"
//         >
//           Edit
//         </button>
//       </div>

//       {/* ✅ Delete Modal */}
//       <DeleteModal
//         open={modalOpen}
//         onClose={() => setModalOpen(false)}
//         onDelete={handleDelete}
//         profileType={isPetParent ? "Pet Parent Profile" : "Veterinarian Profile"}
//       />
//     </div>
//   );
// }


import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import DetailView from "../../components/details/DetailView";
import { fetchUserById, deleteUser, clearProfile } from "../../redux/slices/userSlice";

export default function UserProfile() {
  const { type, id } = useParams();
  const userType = type;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const profile = useSelector((state) => state.users.profile);
  const profileStatus = useSelector((state) => state.users.profileStatus);

  useEffect(() => {
    dispatch(fetchUserById({ userType, id }));
    return () => dispatch(clearProfile());
  }, [dispatch, userType, id]);

  if (profileStatus === "loading") return <div className="px-20 pt-10">Loading...</div>;
  if (profileStatus === "failed") return <div className="px-20 pt-10">Failed to load user data.</div>;
  if (!profile) return <div className="px-20 pt-10">User not found.</div>;

  const handleDelete = () => {
    dispatch(deleteUser({ userType, id }));
    navigate(-1); // Go back after delete
  };

  const handleEdit = () => {
    navigate(`/swift-app/admin/profile/${userType}/${id}/edit`);
  };

  return (
    <DetailView
      title={userType === "pet-parents" ? "Pet Parent Profile" : "Veterinarian Profile"}
      type={userType === "pet-parents" ? "pet-parent" : "veterinarian"}
      data={profile}
      onDelete={handleDelete}
      onEdit={handleEdit}
    />
  );
}
